<se-icon
  accent="true"
  class="{{ iconColor }}"
  name="{{ iconName }}"
  size="{{ size }}">
</se-icon>